// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1P1vq","clinicsSelect":"styles_clinicsSelect__1I0Cq"};